<template>
  <div>
    <v-text-field
      v-model="item.descricao"
      label="Descrição do modulo"
      clearable
      outlined
    />

    <v-text-field
      v-model="item.icon"
      label="Icone do modulo"
      :append-icon="item.icon"
      clearable
      outlined
    />

    <v-text-field
      v-model="item.link"
      label="Link do modulo"
      clearable
      outlined
    />
  </div>
</template>

<script>
export default {
  model: {
    prop: 'item',
    event: 'change-item'
  },
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    ITEM_COMPUTED: {
      get() { this.item },
      set(valor) { this.$emit('change-item', valor) }
    }
  }
}
</script>

<style>

</style>
